import { createContext } from 'react';

export const createNamedContext = <T>(defaultValue: T, name: string) => {
  const ctx = createContext<T>(defaultValue);

  ctx.displayName = name;

  return ctx;
};
